<template>
    <div v-show="show" class="background">
        <div class="user-record-dialog common-dialog window-scale">
            <div class="title">
                <span class="title-txt">班級紀錄</span>
                <div class="close-btn" @click="handleClose"></div>
            </div>
            <div class="banner"></div>
            <div class="content">
                <RecordItem v-show="autoRecord.log_name != null" :record-name="autoRecord.log_name"
                    :record-time="autoRecord.update_time" :record-file-path="autoRecord.file_path"
                    :record-id="autoRecord.id" :is-auto-record="true" />
                <template v-for="item in userRecord" :key="item.id">
                    <RecordItem v-if="checkRecordDelete(item)" :record-name="item.log_name" :record-time="item.update_time"
                        :record-file-path="item.file_path" :record-id="item.id" :is-auto-record="false" />
                </template>
                <!-- <RecordItem v-for="item in userRecord" :record-name="item.log_name" :record-time="item.update_time"
                    :record-file-path="item.file_path" :record-id="item.id" /> -->
            </div>
            <div class="buttons">
                <div v-show="store.nowView == VIEW_TYPE.PC || store.nowView == VIEW_TYPE.MAC" class="light-orange-btn btn-txt dialog-btn"
                    @click="handleSelectOtherRecord">開啟其他紀錄</div>
                <div v-show="store.nowView != VIEW_TYPE.WEB" class="light-orange-btn btn-txt dialog-btn"
                    @click="handleFetchRecord">同步紀錄</div>
                <div class="blue-btn btn-txt dialog-btn" @click="handleClose">開啟電子書</div>
            </div>
        </div>
    </div>
</template>

<script>
import AppRenderer from '../../../js/app_renderer';
import RecordItem from './RecordItem.vue';
import EventBus from '../../../js/event_bus';
import { useUserStore } from '../../../js/user_data';
import SaveTool from '../../../js/toolbar/save_tool';
import { store } from '../../../store';
import { VIEW_TYPE } from '@/js/view_type';
export default {
    name: "UserRecord",
    data: function () {
        return {
            show: false,
            userRecord: [],
            autoRecord: {
                log_name: null,
                update_time: null,
                file_path: null,
                id: null,
            },
            store,
            VIEW_TYPE
        }
    },
    components: {
        RecordItem
    },
    methods: {
        setUserRecord(data, autoSaveData) {
            //console.log("all data:", data);
            this.userRecord = data;
            this.sortUserRecord();

            if (autoSaveData) {
                this.autoRecord = autoSaveData;
            }
        },
        sortUserRecord() {
            // 降冪排列
            this.userRecord = this.userRecord.sort(function (a, b) {
                return a.update_time < b.update_time ? 1 : -1;
            })
        },
        handleClose() {
            this.show = false
        },
        handleSelectOtherRecord() {
            AppRenderer.Instance.selectOtherRecord();
        },
        handleFetchRecord() {
            const USER_DATA = useUserStore();
            store.fetchCloudRecord = true;
            if (USER_DATA.userId.length > 0) {
                EventBus.getInstance().getAppRefs().fetchRecord.showFetchRecord(this.userRecord);
            } else {
                SaveTool._instance.handleLogin()();
            }
        },
        checkRecordDelete(record) {
            // 判斷書本紀錄是否為刪除狀態
            if (store.nowView == VIEW_TYPE.WEB || store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) {
                return record.save_staus != 'delete';
            } else {
                return record.status != 'delete';
            }
        }
    },
    watch: {
        show: function (newValue) {
            if (newValue == true) {
                AppRenderer.Instance.detectRecordFolder();
            }
        }
    }
}
</script>
<style src="../../../css/dialog_style.css" scoped ></style>
<style scoped>
.background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #0000006e;
}

.user-record-dialog {
    position: absolute;
    width: 1152px;
    height: 800px;
    min-height: 300px;

    background: white;
    border: rgb(0, 89, 173) 0.2rem solid;
    border-radius: 2rem;
    z-index: var(--z-index-user-record);

    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    display: flex;
    flex-direction: column;
    align-items: center;
}

.title-txt {
    font-size: 2rem;
    color: black;
    font-weight: bolder;
}

.banner {
    background: rgb(0, 89, 173);
    width: 80%;
    height: 5%;
    margin-top: 0.5rem;
    border-radius: 0.2rem;
}

.content {
    width: 90%;
    height: 80%;
    overflow-y: scroll;
}

.content::-webkit-scrollbar {
    width: 20px;
}

.content::-webkit-scrollbar-track {
    background: #ffffff;
}

.content::-webkit-scrollbar-thumb {
    background: #d9d9d9;
}

.content::-webkit-scrollbar-thumb:hover {
    background: #808080;
}

.buttons {
    width: 80%;
    height: 2.5rem;
    display: flex;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    justify-content: space-around;
}

.close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
}
</style>